import { useActiveUnit } from "components/Unit";
import { atom, useAtom } from "jotai";

const isBookViewingDrawer = atom(false);

const useBookViewingDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isBookViewingDrawer);
  const unit = useActiveUnit();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const open = (unit) => {
    setIsOpen(true);
  };

  return { toggle, open, isOpen, unit };
};

export { useBookViewingDrawer };
